export default __webpack_public_path__ + "static/google-reviews-color-9b32d6c4551b5cad445ddf0c859dbdfc.svg";